import * as yup from 'yup';

export const SocialCareEventDocumentSchema = yup.object({
  residentId: yup.string().required(),
  socialCareEventName: yup.string().required(),
  socialCareEventId: yup.string().notRequired().nullable(),
  notParticipated: yup.boolean().required(),
  description: yup.string().notRequired().nullable(),
  date: yup.date().required(),
});

export interface ISocialCareEventDocument {
  residentId: string;
  socialCareEventName: string;
  socialCareEventId?: string;
  notParticipated: boolean;
  description?: string;
  date: Date;
}

export const SocialCareGroupEventDocumentSchema = yup.object({
  documents: yup.array(SocialCareEventDocumentSchema).required(),
});

export interface ISocialCareGroupEventDocument {
  documents: ISocialCareEventDocument[];
}

export const UpdateSocialCareEventDocumentSchema = yup.object({
  id: yup.string().required(),
  residentId: yup.string().notRequired().nullable(),
  socialCareEventName: yup.string().notRequired().nullable(),
  socialCareEventId: yup.string().notRequired().nullable(),
  notParticipated: yup.boolean().notRequired().nullable(),
  description: yup.string().notRequired().nullable(),
  date: yup.date().notRequired().nullable(),
});

export interface IUpdateSocialCareEventDocument {
  id: string;
  residentId?: string;
  socialCareEventName?: string;
  socialCareEventId?: string;
  notParticipated?: boolean;
  description?: string;
  date?: Date;
}
